import React, { useCallback } from "react";
import Dashboard from "../../layouts/Dashboard";
import { useParams } from "react-router-dom";
import { useReport } from "../../apis/reportsApi.hooks";
import { Grid, Loader, Text } from "@pushpress/shared-components";
import HeaderTitle from "../../components/HeaderTitle";
import Looker from "./Looker";
import QuickSight from "./QuickSight";
import styles from "./Reports.module.scss";
import { useFeatureFlag } from "../../context/features";

function ReportsContent() {
  const { isFeatureEnabled } = useFeatureFlag();
  const { slug } = useParams<{ slug: string }>();
  const { data: report, isLoading: isReportLoading } = useReport(slug);

  const Component = useCallback(() => {
    if (isReportLoading) {
      return (
        <Grid container justifyContent="center" alignItems="center">
          <Grid item>
            <Loader />
          </Grid>
        </Grid>
      );
    }

    if (
      !report ||
      (!!report.fields.featureFlag &&
        !isFeatureEnabled(report.fields.featureFlag))
    ) {
      return (
        <Grid container justifyContent="center" alignItems="center">
          <Grid item>
            <Text variant="heading-4" color="wolf-600">
              Report not found
            </Text>
          </Grid>
        </Grid>
      );
    }

    if (report?.fields.looker) {
      return (
        <div data-cy="looker" className={styles.container}>
          <Looker report={report} key={report?.fields.dashboardId} />
        </div>
      );
    }

    return (
      <div data-cy="quicksight" className={styles.container}>
        <QuickSight report={report} />
      </div>
    );
  }, [report, isReportLoading]);

  return (
    <>
      <HeaderTitle title={report?.fields.name || "Reports"} />
      <Component />
    </>
  );
}

function Reports() {
  return (
    <Dashboard>
      <ReportsContent />
    </Dashboard>
  );
}

export default Reports;
